import { IElementWithVideo } from '../interfaces/IElementWithVideo';
import BeaconOrderPageVideoWEBM from '../assets/videos/beacon-order.webm';
import BeaconOrderPageVideoMP4 from '../assets/videos/beacon-order.mp4';

export const PARTNER_BEACON_ORDER_PAGE_VIDEO_SRC: IElementWithVideo['videoSrcs'] =
  [
    { src: BeaconOrderPageVideoWEBM, type: 'video/webm' },
    { src: BeaconOrderPageVideoMP4, type: 'video/mp4' },
  ];

export const PARTNER_BEACON_ORDER_PAGE_ADVANTAGES = [
  {
    heading: 'SAVE TIME & MONEY',
    body: 'Take a few photos of any property and receive all of the exterior measurements you need.',
  },
  {
    heading: 'CLOSE MORE BUSINESS',
    body: 'Show homeowners what new products and colors will look like and see up to a 15% increase in your close rates.',
  },
  {
    heading: 'ORDER MATERIALS QUICKLY',
    body: '3D+ auto-calculates the exact amount of products you need so you can order seamlessly on Beacon Pro+.',
  },
];
